import { CascadiaColor, CascadiaTypographyStyle } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { useMemo } from "react";
import { mergeProps } from "react-aria";
import { Label as AriaLabel, LabelProps } from "react-aria-components";

import { useColors } from "../../hooks/useColors";
import { getTextStyle } from "../../foundations/typography/styles";

interface Props extends Omit<LabelProps, "style"> {
  style?: CascadiaTypographyStyle;
  color?: CascadiaColor;
}

export function _Label(props: Props) {
  const { style = "input/label", color = "text-base", ...labelProps } = props;

  const colors = useColors();

  const className = useMemo(() => {
    return css(getTextStyle(style), { color: colors[color] });
  }, [colors, style, color]);

  return <AriaLabel {...mergeProps(labelProps, { className })} />;
}
